import { authenticationConstants } from "../_constants/";


const initalState = {
    user: {},
    authenticated: false,
};

const user = localStorage.getItem("user");
if (user != null) {
    initalState.user = JSON.parse(user);
    initalState.authenticated = true;
}

export function authentication(state = initalState, action:any)
{
    switch (action.type) {
        case authenticationConstants.AUTHENTICATION_FAILED:
            return {
                ...state,
                authenticated: false
            };
        case authenticationConstants.AUTHENTICATION_SUCCESSFUL:
            return {
                ...state,
                authenticated: true,
                user: action.user
            };
        case authenticationConstants.AUTHENTICATION_LOGOUT:
            return {
                ...state,
                authenticated: false,
                user: {}
            };
        default:
            return state;
    }
}